import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["id", "value", "prefix", "suffix", "allowNegative", "thousandSeparator", "editMode", "onChange", "maxValue", "decimalScale", "fixedDecimalScale", "className", "aria-labelledby", "helperText", "margin", "label"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import NumberFormat from "react-number-format";
import FieldBase from "componentLibrary/Fields/FieldBase";
import NumberInput from "./NumberInput";
import { makeStyles, RaiseColors } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    root: {
      backgroundColor: RaiseColors.white,
      borderRadius: "8px",
      border: "1px solid ".concat(RaiseColors.grayscale200)
    },
    input: {
      padding: "8px 16px",
      boxSizing: "border-box",
      minHeight: 36
    }
  };
});
var NumberField = function NumberField(_ref) {
  var id = _ref.id,
    value = _ref.value,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    allowNegative = _ref.allowNegative,
    _ref$thousandSeparato = _ref.thousandSeparator,
    thousandSeparator = _ref$thousandSeparato === void 0 ? true : _ref$thousandSeparato,
    _ref$editMode = _ref.editMode,
    editMode = _ref$editMode === void 0 ? true : _ref$editMode,
    onChange = _ref.onChange,
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === void 0 ? null : _ref$maxValue,
    _ref$decimalScale = _ref.decimalScale,
    decimalScale = _ref$decimalScale === void 0 ? 4 : _ref$decimalScale,
    _ref$fixedDecimalScal = _ref.fixedDecimalScale,
    fixedDecimalScale = _ref$fixedDecimalScal === void 0 ? false : _ref$fixedDecimalScal,
    className = _ref.className,
    ariaLabelledby = _ref["aria-labelledby"],
    helperText = _ref.helperText,
    margin = _ref.margin,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  if (editMode) {
    return /*#__PURE__*/_jsx(FieldBase, _objectSpread(_objectSpread({}, props), {}, {
      htmlFor: id,
      helperText: helperText,
      margin: margin,
      label: label,
      children: /*#__PURE__*/_jsx(NumberInput, _objectSpread({
        id: id,
        "aria-labelledby": ariaLabelledby,
        prefix: prefix,
        suffix: suffix,
        value: value,
        onChange: onChange,
        maxValue: maxValue,
        thousandSeparator: thousandSeparator,
        decimalScale: decimalScale,
        fixedDecimalScale: fixedDecimalScale,
        allowNegative: allowNegative,
        classes: {
          root: classes.root,
          input: classes.input
        },
        "data-testid": "number-input"
      }, props))
    }));
  }
  return /*#__PURE__*/_jsx(NumberFormat, {
    className: className,
    value: value,
    displayType: "text",
    thousandSeparator: thousandSeparator !== null && thousandSeparator !== void 0 ? thousandSeparator : true,
    suffix: " ".concat(suffix || ""),
    prefix: " ".concat(prefix || ""),
    decimalScale: decimalScale,
    fixedDecimalScale: fixedDecimalScale,
    allowNegative: allowNegative,
    "data-testid": "number-format"
  });
};
export default NumberField;